// third-party

// assets
import {
  LineChartOutlined,
  IdcardOutlined,
  DatabaseOutlined,
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined
} from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined,
  LineChartOutlined,
  IdcardOutlined,
  DatabaseOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const Plugins: NavItemType = {
  id: 'group-plugins',
  icon: icons.IdcardOutlined,
  type: 'group',
  children: [
    {
      id: 'plugins',
      title: 'Plugins',
      type: 'collapse',

      icon: icons.FileTextOutlined,
      breadcrumbs: true,
      children: [
        {
          id: 'plugins-well-ressum',
          title: 'Well Ressum',
          type: 'item',
          url: '/plugins/well-ressum'
        },
        {
          id: 'plugins-plugin2',
          title: 'Plugin 2',
          type: 'item',
          url: '/plugins/plugin2'
        },
        {
          id: 'plugins-plugin3',
          title: 'Plugin 3',
          type: 'item',
          url: '/plugins/plugin3'
        },
        {
          id: 'plugins-plugin4',
          title: 'Plugin 4',
          type: 'item',
          url: '/plugins/plugin4'
        }
      ]
    }
  ]
};

export default Plugins;
